import React, { useCallback, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, parseNumberByPrecision, useOutsideClick } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
// import { toJS } from 'mobx';
import { doBetStore } from '../../store/doBetStore';
import { soundService, soundTypes } from '../../services/SoundService';
import { gameStore } from '../../store/gameStore';

export const AmountSection = observer(() => {
  const { quickBets, selectedAmount, setSelectedAmount } = doBetStore;
  const { precision, balance } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const { isBetsClosed } = gameStore;
  const quickBetsRef = useRef();
  const [opened, handleClick] = useOutsideClick(quickBetsRef);
  const handleSelectAmount = useCallback(
    (amount) => {
      setSelectedAmount(amount);
      soundService.play(soundTypes.chip);
    },
    [setSelectedAmount]
  );

  return (
    <div
      className={`bet-amount-button-container ${opened ? 'active' : ''} ${
        isBetsClosed || activeFreeBet.id ? 'inactive' : ''
      }`}
      onClick={() => {
        handleClick();
        soundService.play(soundTypes.amount);
      }}
      ref={quickBetsRef}
    >
      {/* added/remove class active */}
      <div className='coins-icon-container'>
        <div className='coins-button-inner'>
          <i className='icon-tp-coins' />
        </div>
      </div>
      <div className='bet-amount-button'>
        <p className='bet-amount-text'>
          {parseNumberByPrecision(
            1,
            activeFreeBet.id ? activeFreeBet.amount : selectedAmount,
            +precision
          )}
        </p>
      </div>
      <div className='drop-up-icon-container'>
        <i className='icon-tp-top' />
      </div>
      <div className='slider-up-wrapper'>
        <div className='slider-up-container'>
          <div className='slider-up-content'>
            {quickBets.map((item) => {
              const amount = parseNumberByPrecision(1, item, +precision);
              return (
                <div
                  className={`slider-inner ${item > balance ? 'inactive' : ''} ${
                    item === selectedAmount ? 'active' : ''
                  }`}
                  key={item}
                  onClick={() => {
                    handleSelectAmount(amount);
                  }}
                >
                  <p className='bet-amount-text slider-inner-text'>{amount}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
});
